exports.components = {
  "component---src-app-pages-index-jsx": () => import("./../../../src/_app/Pages/index.jsx" /* webpackChunkName: "component---src-app-pages-index-jsx" */),
  "component---src-app-posts-index-jsx": () => import("./../../../src/_app/Posts/index.jsx" /* webpackChunkName: "component---src-app-posts-index-jsx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

